// Used for displaying the value of a dropdown (using DropDownEditor) when not editing it.
// Accepts the same parameters as the DropDownEditor.
import { memo } from 'react';

const React = require('react');
import PropTypes from 'prop-types';

const DropDownFormatter = props => {
  let value = props.value;
  let option = props.options.filter(function(v) {
    return v === value || v.value === value;
  })[0];
  if (!option) {
    option = value;
  }
  let title = option.title || option.value || option;
  let text = option.text || option.value || option;
  return <div title={title}>{text}</div>;
};

DropDownFormatter.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        value: PropTypes.string,
        text: PropTypes.string,
      }),
    ])
  ).isRequired,
  value: PropTypes.string.isRequired,
};

module.exports = memo(DropDownFormatter, (prevProps, nextProps) => prevProps.value === nextProps.value);
